import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Zap, Wrench, Smartphone, ArrowRight, Check } from 'lucide-react';

const PERKS = [
  {
    icon: Shield,
    badge: 'PRISGARANTI',
    title: 'Saving Mode prisgaranti',
    body: 'Du afregnes til prisen for de billigste timer i din ladeperiode – uanset hvornår bilen faktisk lader. Du skal ikke selv jagte timer eller sætte timere.',
    to: '/portal/smart-charge',
    linkText: 'Sådan virker prisgarantien',
  },
  {
    icon: Zap,
    badge: 'LADERABAT',
    title: '10 øre/kWh i laderabat',
    body: 'Oven i prisgarantien trækker vi 0,10 kr./kWh inkl. moms fra automatisk på din el-regning for al opladning via enkel-appen.',
    to: '/el-fordele#laderabat',
    linkText: 'Beregn din laderabat',
  },
  {
    icon: Wrench,
    badge: '0 KR./MD.',
    title: 'Gratis serviceaftale',
    body: 'Software-opdateringer, fjernsupport, fejlfinding og automatisk elafgift-refusion på din ladeboks – uden ekstra abonnement.',
    to: '/service-aftale',
    linkText: 'Se serviceaftalen',
  },
  {
    icon: Smartphone,
    badge: 'APP',
    title: 'enkel Saving Mode app',
    body: 'Planlæg opladning, sæt afgangstider og følg forbrug og besparelser. Opladningen kører automatisk i de billigste timer.',
    to: '/enkel-app',
    linkText: 'Se app-guiden',
  },
];

export default function PowerfuelEvPerks() {
  return (
    <section id="powerfuel-ev" className="py-16 md:py-20 bg-[#f5f3ee] scroll-mt-20">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block bg-[#eab308] text-[#1a2e1a] text-xs font-bold px-3 py-1 rounded-full mb-3">GRATIS FOR ELBIL-EJERE</span>
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a2e1a] mb-3" style={{ fontFamily: '"Playfair Display", Georgia, serif' }}>
              Du er landet hos et elselskab bygget til elbiler
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Powerfuel-kunder er elbil-ejere – og det er præcis dér, vi er stærkest. Alle fordele herunder er gratis,
              kræver ingen binding og påvirker ikke din ret til at opsige den tildelte aftale.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-5 mb-10">
            {PERKS.map((p, i) => {
              const Icon = p.icon;
              return (
                <div key={i} className="bg-white rounded-2xl border border-[#e8e4d9] p-6 flex flex-col">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-[#1a2e1a] rounded-lg flex items-center justify-center flex-shrink-0">
                      <Icon className="w-5 h-5 text-[#eab308]" />
                    </div>
                    <div>
                      <span className="inline-block bg-[#eab308] text-[#1a2e1a] px-2 py-0.5 rounded text-[10px] font-bold mb-1">{p.badge}</span>
                      <h3 className="font-bold text-[#1a2e1a] text-base leading-tight">{p.title}</h3>
                    </div>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed flex-1">{p.body}</p>
                  <Link to={p.to} className="text-[#1a2e1a] font-semibold text-sm mt-4 inline-flex items-center gap-1 hover:underline">
                    {p.linkText} <ArrowRight className="w-3.5 h-3.5" />
                  </Link>
                </div>
              );
            })}
          </div>

          <div className="bg-white border border-[#e8e4d9] rounded-2xl p-6">
            <h3 className="font-bold text-[#1a2e1a] text-sm mb-3">Kompatible ladebokse</h3>
            <div className="grid grid-cols-3 gap-2 mb-3">
              {['Zaptec', 'NexBlue', 'Easee'].map((name) => (
                <div key={name} className="bg-[#f5f3ee] px-3 py-2 rounded-lg text-xs font-medium text-[#1a2e1a] flex items-center gap-2">
                  <Check className="w-3 h-3 text-[#1a2e1a] flex-shrink-0" />
                  <span>{name}</span>
                </div>
              ))}
            </div>
            <p className="text-xs text-gray-500">
              Har du en ladeboks fra et af disse mærker? Så kan vi aktivere dine EV-fordele – tilmeld dig længere nede på siden.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}